import { apiClient } from '@/core/api/client';
export async function enviarLog(entry) {
    await apiClient.post('/api/log', entry, {
        headers: { 'X-Skip-Auth': '1' },
    });
}
